 @if(!hideTitle) {
<div class="row">
  <div class="order-details col text-secondary">
    <small>Order details</small>
  </div>
</div>
 }
@if (order && order.salesOrderNumber) {
<div class="row" style="padding-top: 0.4rem">
  <div class="order-number col-2 text-nowrap fs-5 fw-bold">
    <span>Order {{order.salesOrderNumber}}</span>
  </div>
  <div class="col-1 text-center">&nbsp;</div>
  <div class="col-2 text-nowrap fs-5">&nbsp;</div>
  <div class="col-7 text-end">
    <div class="d-flex justify-content-end">
      <button class="export-data btn btn-outline-primary btn-sm btn-panel text-nowrap d-flex align-items-center" style="width: auto;" (click)="showDialog()" [disabled]="!orderCoilsExists"><i class="material-icons-outlined">file_download</i>&nbsp;&nbsp;Export all data</button>
    </div>
  </div>
<app-export-dialog 
  [showExportDialog]="showExportDialog" 
  (displayChange)="onDialogClose($event)">
</app-export-dialog>
</div>
<div class="row my-4">
  <div class="order-info col-3 text-nowrap">Customer Order # <br /> <span class="order-data">{{order.customerOrderNumber}}</span></div>
  <div class="order-info col-3 text-nowrap" style="margin-right: 1rem; margin-left: 1rem;">Product type <br /><span class="order-data">{{order.productType}}</span></div>
  <div class="order-info col-3 text-nowrap">Order date <br /><span class="order-data">{{order.orderDate | date: 'dd-MM-yyyy'}}</span></div>
  <div class="col-1">&nbsp;</div>
</div>
<section class="coil-detail-container" tabindex="0">
<table mat-table  aria-describedby="orderdetailstable" [dataSource]="rowDataCoil">
  <ng-container matColumnDef="coilSheetId">
    <th mat-header-cell *matHeaderCellDef> Coil # </th>
    <td mat-cell *matCellDef="let row"> {{row.coilSheetId}} </td>
  </ng-container>

  <ng-container matColumnDef="width">
    <th mat-header-cell *matHeaderCellDef> Width ({{regionMeasurementUnits.width_thickness}}) </th>
    <td mat-cell *matCellDef="let row"> {{row.width}} </td>
  </ng-container>

  <ng-container matColumnDef="thickness">
    <th mat-header-cell *matHeaderCellDef> Thickness ({{regionMeasurementUnits.width_thickness}}) </th>
    <td mat-cell *matCellDef="let row"> {{row.thickness}} </td>
  </ng-container>

  <ng-container matColumnDef="gradeType">
    <th mat-header-cell *matHeaderCellDef> Steel grade </th>
    <td mat-cell *matCellDef="let row"> {{row.gradeType}} </td>
  </ng-container>

  <ng-container matColumnDef="coilDetails">
    <th mat-header-cell *matHeaderCellDef> Coil details </th>
    <td mat-cell *matCellDef="let row"> <button class="mat-button" mat-button color="primary" (click)="openCoilDetailDialog(row)">View details</button>
</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns sticky: true"></tr>
  <tr mat-row class="table-row" *matRowDef="let row; columns: displayedColumns;" [class.selected]="row.selected" (click)="onRowClicked(row)"></tr>
</table>
</section>
 } @else {
  <div class="d-flex justify-content-center align-items-center h-100">
    <img src="assets/images/no-results.svg" alt="Tata Steel logo" />
  </div>
} 